/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//   Generated using Swaggie (https://github.com/yhnavein/swaggie)
//   Please avoid doing any manual changes in this file
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// biome-ignore-all lint: auto-generated code
// deno-lint-ignore-file

import ky, {type KyInstance, type Options as KyOptions} from 'ky';
import {createKyConfig} from './setup';

let _http: KyInstance | null = null;

/**
 * Initialises the ky HTTP client using the configuration returned by
 * `createKyConfig()` from your setup file.
 *
 * Call this once at application startup — for example inside a React provider
 * or your app's entry point — before any API calls are made.
 *
 * Re-calling this function replaces the existing instance. ky instances are
 * immutable, so hook changes require re-initialisation.
 */
export function initKyHttp(): void {
  _http = ky.create(createKyConfig());
}

/**
 * Returns the initialised ky instance. Throws if called before `initKyHttp()`.
 *
 * This guard prevents accidental use of the client before it has been
 * configured with hooks (auth, error handling, etc.).
 */
export function getKyHttp(): KyInstance {
  if (!_http) {
    throw new Error(
      '[Swaggie] ky client is not initialised. ' +
        'Call initKyHttp() at application startup before making any API requests.',
    );
  }
  return _http;
}
export const organizationsClient = {
  /**
   * Delete a single organization entity by its ID
   * @param organizationId - Organization Identifier
   */
  deleteOrganization(organizationId: string, $config?: KyOptions): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Get a single organization entity by its ID
   * @param organizationId - Organization Identifier
   */
  getOrganization(organizationId: string, $config?: KyOptions): Promise<GetOrganizationResponse> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<GetOrganizationResponse>();
  },

  /**
   * Request organization license upgrade to Enterprise
   * @param body
   * @param organizationId - Organization Identifier
   */
  requestOrganizationLicenseUpgrade(
    body: OrganizationLicenseUpgradeRequest,
    organizationId: string,
    $config?: KyOptions,
  ): Promise<OrganizationLicenseUpgradeResponse> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/license/upgrade-request`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<OrganizationLicenseUpgradeResponse>();
  },

  /**
   * Update a single organization entity by its ID
   * @param body
   * @param organizationId - Organization Identifier
   */
  updateOrganization(
    body: UpdateOrganizationRequest,
    organizationId: string,
    $config?: KyOptions,
  ): Promise<UpdateOrganizationResponse> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}`;

    return getKyHttp()
      .put(url, {
        json: body,
        ...$config,
      })
      .json<UpdateOrganizationResponse>();
  },
};

export const auditLogsClient = {
  /**
   * Create an audit log forwarding config for an organization
   * @param body
   * @param organizationId - Organization Identifier
   */
  createAuditLogForwardingConfig(
    body: CreateAuditLogForwardingConfigRequest,
    organizationId: string,
    $config?: KyOptions,
  ): Promise<AuditLogForwardingConfig> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/audit-log-forwarding-configs`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<AuditLogForwardingConfig>();
  },

  /**
   * Delete a forwarding config for an organization
   * @param organizationId - Organization Identifier
   * @param forwardingConfigId
   */
  deleteAuditLogForwardingConfig(
    organizationId: string,
    forwardingConfigId: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/audit-log-forwarding-configs/${encodeURIComponent(`${forwardingConfigId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Fetch a single forwarding config for an organization
   * @param organizationId - Organization Identifier
   * @param forwardingConfigId
   */
  getAuditLogForwardingConfig(
    organizationId: string,
    forwardingConfigId: string,
    $config?: KyOptions,
  ): Promise<AuditLogForwardingConfig> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/audit-log-forwarding-configs/${encodeURIComponent(`${forwardingConfigId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<AuditLogForwardingConfig>();
  },

  /**
   * Query audit log forwarding configs for an organization
   * @param organizationId - Organization Identifier
   */
  getAuditLogForwardingConfigsByOrganization(
    organizationId: string,
    $config?: KyOptions,
  ): Promise<AuditLogForwardingConfig[]> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/audit-log-forwarding-configs`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<AuditLogForwardingConfig[]>();
  },

  /**
   * Query audit logs for an organization
   * @param organizationId - Organization Identifier
   * @param queryParams (optional) - Grouped query parameters object (from, to, limit)
   */
  getAuditLogsByOrganization(
    organizationId: string,
    queryParams?: {from?: string | null; to?: string | null; limit?: number | null} | null,
    $config?: KyOptions,
  ): Promise<AuditLog[]> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/audit-logs`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          from: queryParams?.from,
          to: queryParams?.to,
          limit: queryParams?.limit,
        }),
        ...$config,
      })
      .json<AuditLog[]>();
  },

  /**
   * Send a sample audit log event based on a provided forwarding configuration
   * @param body
   * @param organizationId - Organization Identifier
   */
  testAuditLogForwardingConfig(
    body: CreateAuditLogForwardingConfigRequest,
    organizationId: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/audit-log-forwarding-configs/test`;

    return getKyHttp().post(url, {
      json: body,
      ...$config,
    });
  },

  /**
   * Update a forwarding config for an organization
   * @param body
   * @param organizationId - Organization Identifier
   * @param forwardingConfigId
   */
  updateAuditLogForwardingConfig(
    body: UpdateAuditLogForwardingConfigRequest,
    organizationId: string,
    forwardingConfigId: string,
    $config?: KyOptions,
  ): Promise<AuditLogForwardingConfig> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/audit-log-forwarding-configs/${encodeURIComponent(`${forwardingConfigId}`)}`;

    return getKyHttp()
      .patch(url, {
        json: body,
        ...$config,
      })
      .json<AuditLogForwardingConfig>();
  },
};

export const clientsClient = {
  /**
   * Create a new API Client
   * @param body
   * @param organizationId - Organization Identifier
   */
  createApiClient(body: ClientCreate, organizationId: string, $config?: KyOptions): Promise<Client> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/clients`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<Client>();
  },

  /**
   * Deletes a single API Client in an organization
   * Deletes a single API Client from an organization
   * @param organizationId - Organization Identifier
   * @param clientId - API Credential Client Internal Identifier
   */
  deleteApiClient(organizationId: string, clientId: string, $config?: KyOptions): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/clients/${encodeURIComponent(`${clientId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Deletes all API Clients in an organization
   * Deletes all API Clients from an organization
   * @param organizationId - Organization Identifier
   */
  deleteApiClients(organizationId: string, $config?: KyOptions): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/clients`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Get an API Client by clientId
   * @param organizationId - Organization Identifier
   * @param clientId - API Credential Client Internal Identifier
   */
  getApiClient(organizationId: string, clientId: string, $config?: KyOptions): Promise<Client> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/clients/${encodeURIComponent(`${clientId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Client>();
  },

  /**
   * Get Api Client Secret
   * @param organizationId - Organization Identifier
   * @param clientId - API Credential Client Internal Identifier
   */
  getApiClientSecret(organizationId: string, clientId: string, $config?: KyOptions): Promise<{secret?: string}> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/clients/${encodeURIComponent(`${clientId}`)}/secret`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<{secret?: string}>();
  },

  /**
   * Get all API Credential Clients for an organization
   * @param organizationId - Organization Identifier
   */
  getApiClientsByOrganization(organizationId: string, $config?: KyOptions): Promise<Client[]> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/clients`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Client[]>();
  },

  /**
   * Get all API Credential Clients for a workspace
   * @param organizationId - Organization Identifier
   * @param workspaceId - Workspace name (ie. main)
   */
  getApiClientsByWorkspace(
    organizationId: string,
    workspaceId: string,
    $config?: KyOptions,
  ): Promise<WorkspaceClient[]> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/clients`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<WorkspaceClient[]>();
  },

  /**
   * Update an API Client
   * @param body
   * @param organizationId - Organization Identifier
   * @param clientId - API Credential Client Internal Identifier
   */
  updateApiClient(body: ClientUpdate, organizationId: string, clientId: string, $config?: KyOptions): Promise<Client> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/clients/${encodeURIComponent(`${clientId}`)}`;

    return getKyHttp()
      .patch(url, {
        json: body,
        ...$config,
      })
      .json<Client>();
  },
};

export const connectionsClient = {
  /**
   * Deletes the current SSO connection
   * Delete the current SSO connection. Be sure to warn the user first; this is a dangerous operation.
   * @param organizationId - Organization Identifier
   */
  deleteSSOConnection(organizationId: string, $config?: KyOptions): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/connections/sso`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Returns the current SSO connection
   * Gets either an OIDC or SAML SSO connection for an organization (only 1 is permitted)
   * @param organizationId - Organization Identifier
   */
  getSSOConnection(organizationId: string, $config?: KyOptions): Promise<Connection> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/connections/sso`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Connection>();
  },

  /**
   * Update the SSO connection
   * Update either an OIDC or SAML SSO connection for an organization
   * @param body
   * @param organizationId - Organization Identifier
   */
  patchSSOConnection(body: UpdateConnection, organizationId: string, $config?: KyOptions): Promise<Connection> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/connections/sso`;

    return getKyHttp()
      .patch(url, {
        json: body,
        ...$config,
      })
      .json<Connection>();
  },

  /**
   * Create the SSO connection
   * Creates either an OIDC or SAML SSO connection for an organization (only 1 is permitted)
   * @param body
   * @param organizationId - Organization Identifier
   */
  postSSOConnection(
    body: CreateOIDCConnectionRequest | CreateSAMLConnectionRequest,
    organizationId: string,
    $config?: KyOptions,
  ): Promise<Connection> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/connections/sso`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<Connection>();
  },
};

export const invitesClient = {
  /**
   * Delete an invite
   * @param organizationId - Organization Identifier
   * @param inviteId - Invite Identifier
   */
  deleteInvite(organizationId: string, inviteId: string, $config?: KyOptions): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/invites/${encodeURIComponent(`${inviteId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Get a list of invites for an organization
   * @param organizationId - Organization Identifier
   */
  getInvites(organizationId: string, $config?: KyOptions): Promise<InviteArray> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/invites`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<InviteArray>();
  },

  /**
   * Invite a user to join an organization
   * @param body
   * @param organizationId - Organization Identifier
   */
  inviteUserToOrganization(
    body: {
      orgRole: 'org_owner' | 'org_admin' | 'org_iam_admin' | 'org_user' | 'billing_reader';
      productRoles?: ProductRole[];
      recipientEmail: string;
      recipientFirstName?: string;
      recipientLastName?: string;
      teams?: {teamIds: string[]; workspaceId: string}[];
      workspaceRoles?: WorkspaceRole[];
    },
    organizationId: string,
    $config?: KyOptions,
  ): Promise<{id?: string}> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/invites`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<{id?: string}>();
  },

  /**
   * Accept an invite to join an organization
   * @param organizationId - Organization Identifier
   * @param inviteId - Invite Identifier
   */
  postAcceptInvite(organizationId: string, inviteId: string, $config?: KyOptions): Promise<{location?: string}> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/invites/${encodeURIComponent(`${inviteId}`)}`;

    return getKyHttp()
      .post(url, {
        ...$config,
      })
      .json<{location?: string}>();
  },

  /**
   * Resend an invite
   * @param organizationId - Organization Identifier
   * @param inviteId - Invite Identifier
   */
  resendInvite(organizationId: string, inviteId: string, $config?: KyOptions): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/invites/${encodeURIComponent(`${inviteId}`)}/resend`;

    return getKyHttp().post(url, {
      ...$config,
    });
  },

  /**
   * Validate and verify an invite
   * Validates that an invitation exists and is in an acceptable state (not expired, revoked, or already accepted), then performs cryptographic verification of the verifier token. Returns the invite details needed to provision the user. This endpoint is non-destructive — it does not change invitation state.
   * @param body
   * @param organizationId - Organization Identifier
   * @param inviteId - Invite Identifier
   */
  validateInvite(
    body: {verifier: string},
    organizationId: string,
    inviteId: string,
    $config?: KyOptions,
  ): Promise<ValidatedInvite> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/invites/${encodeURIComponent(`${inviteId}`)}/validate`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<ValidatedInvite>();
  },
};

export const membersClient = {
  /**
   * Add an existing member to an organization
   * @param body
   * @param organizationId - Organization Identifier
   * @param userId - User Identifier
   */
  addMemberToOrganization(
    body: OrgRole,
    organizationId: string,
    userId: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/members/${encodeURIComponent(`${userId}`)}`;

    return getKyHttp().post(url, {
      json: body,
      ...$config,
    });
  },

  /**
   * Get all the teams for a member of an organization
   * @param organizationId - Organization Identifier
   * @param userId - User Identifier
   */
  getAllTeamsForMember(
    organizationId: string,
    userId: string,
    $config?: KyOptions,
  ): Promise<GetTeamsForMemberResponse> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/members/${encodeURIComponent(`${userId}`)}/teams`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<GetTeamsForMemberResponse>();
  },

  /**
   * Get member roles by workspace
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param userId - User Identifier
   */
  getMemberRolesByWorkspace(
    organizationId: string,
    workspace: string,
    userId: string,
    $config?: KyOptions,
  ): Promise<{orgRole?: OrgRole; productRoles?: ProductRoles; workspaceRole?: WorkspaceRole}> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/members/${encodeURIComponent(`${userId}`)}/roles`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<{orgRole?: OrgRole; productRoles?: ProductRoles; workspaceRole?: WorkspaceRole}>();
  },

  /**
   * Get the roles of a member of an organization
   * @param organizationId - Organization Identifier
   * @param userId - User Identifier
   * @param consistency (optional) - Consistency mode for FGA reads. Use 'high' to ensure strongly-consistent results immediately after a write.
   */
  getOrganizationMemberRoles(
    organizationId: string,
    userId: string,
    consistency?: 'standard' | 'high' | null,
    $config?: KyOptions,
  ): Promise<MemberRoles> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/members/${encodeURIComponent(`${userId}`)}/roles`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          consistency: consistency,
        }),
        ...$config,
      })
      .json<MemberRoles>();
  },

  /**
   * Get members of an organization
   * @param organizationId - Organization Identifier
   */
  getOrganizationMembers(organizationId: string, $config?: KyOptions): Promise<Member[]> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/members`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Member[]>();
  },

  /**
   * Get members of an organization by product
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param product - Product name (ie. stream, lake, or pipeline)
   */
  getOrganizationMembersByProduct(
    organizationId: string,
    workspace: string,
    product: string,
    $config?: KyOptions,
  ): Promise<Member[]> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/products/${encodeURIComponent(`${product}`)}/members`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Member[]>();
  },

  /**
   * Remove a member from an organization
   * @param organizationId - Organization Identifier
   * @param userId - User Identifier
   */
  removeMemberFromOrganization(organizationId: string, userId: string, $config?: KyOptions): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/members/${encodeURIComponent(`${userId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Remove a member from a workspace
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param userId - User Identifier
   */
  removeMemberFromWorkspace(
    organizationId: string,
    workspace: string,
    userId: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/members/${encodeURIComponent(`${userId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Update organization role for a member
   * @param body
   * @param organizationId - Organization Identifier
   * @param userId - User Identifier
   */
  updateOrganizationRoleForMember(
    body: OrgRole,
    organizationId: string,
    userId: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/members/${encodeURIComponent(`${userId}`)}/roles`;

    return getKyHttp().put(url, {
      json: body,
      ...$config,
    });
  },

  /**
   * Update product roles for a member
   * @deprecated
   * @param body
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param userId - User Identifier
   */
  updateProductRolesForMember(
    body: ProductRoles[],
    organizationId: string,
    workspace: string,
    userId: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/members/${encodeURIComponent(`${userId}`)}/roles`;

    return getKyHttp().put(url, {
      json: body,
      ...$config,
    });
  },

  /**
   * Update workspace and/or product roles for a member
   * @param body
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param userId - User Identifier
   */
  updateWorkspaceRolesForMember(
    body: {productRoles?: ProductRoles; workspaceRole?: WorkspaceRole},
    organizationId: string,
    workspace: string,
    userId: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/members/${encodeURIComponent(`${userId}`)}/roles`;

    return getKyHttp().patch(url, {
      json: body,
      ...$config,
    });
  },
};

export const teamsClient = {
  /**
   * Create a new team
   * @param body
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   */
  createNewTeam(body: TeamCreate, organizationId: string, workspace: string, $config?: KyOptions): Promise<Team> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/teams`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<Team>();
  },

  /**
   * Delete a team
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param teamId - Team Identifier
   */
  deleteTeam(organizationId: string, workspace: string, teamId: string, $config?: KyOptions): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/teams/${encodeURIComponent(`${teamId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Get all teams for an organization
   * @param organizationId - Organization Identifier
   * @param excludeMembers (optional)
   */
  getOrganizationTeams(organizationId: string, excludeMembers?: boolean | null, $config?: KyOptions): Promise<Team[]> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/teams`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          excludeMembers: excludeMembers,
        }),
        ...$config,
      })
      .json<Team[]>();
  },

  /**
   * Get a team
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param teamId - Team Identifier
   */
  getTeam(organizationId: string, workspace: string, teamId: string, $config?: KyOptions): Promise<Team> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/teams/${encodeURIComponent(`${teamId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Team>();
  },

  /**
   * Get all teams for a user
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param userId - User Identifier
   */
  getUserTeams(organizationId: string, workspace: string, userId: string, $config?: KyOptions): Promise<Team[]> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/teams/users/${encodeURIComponent(`${userId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Team[]>();
  },

  /**
   * Get all teams for a workspace
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param excludeMembers (optional)
   */
  getWorkspaceTeams(
    organizationId: string,
    workspace: string,
    excludeMembers?: boolean | null,
    $config?: KyOptions,
  ): Promise<Team[]> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/teams`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          excludeMembers: excludeMembers,
        }),
        ...$config,
      })
      .json<Team[]>();
  },

  /**
   * Update team details
   * @param body
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param teamId - Team Identifier
   */
  patchTeam(
    body: TeamUpdate,
    organizationId: string,
    workspace: string,
    teamId: string,
    $config?: KyOptions,
  ): Promise<Team> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/teams/${encodeURIComponent(`${teamId}`)}`;

    return getKyHttp()
      .patch(url, {
        json: body,
        ...$config,
      })
      .json<Team>();
  },
};

export const workspacesClient = {
  /**
   * Delete the workspace
   * @param organizationId - Organization Identifier
   * @param workspaceId - Workspace unique identifier
   */
  deleteWorkspaceById(organizationId: string, workspaceId: string, $config?: KyOptions): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * @param organizationId - Organization Identifier
   * @param workspaceId - Workspace unique identifier
   */
  getInsightsDataRetention(organizationId: string, workspaceId: string, $config?: KyOptions): Promise<{days: number}> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/insightsDataRetention`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<{days: number}>();
  },

  /**
   * Returns the requested workspace
   * @param organizationId - Organization Identifier
   * @param workspaceId - Workspace unique identifier
   */
  getWorkspaceById(organizationId: string, workspaceId: string, $config?: KyOptions): Promise<Workspace> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Workspace>();
  },

  /**
   * Retrieves SMTP config for the workspace
   * @param organizationId - Organization Identifier
   * @param workspaceId - Workspace unique identifier
   */
  getWorkspaceSMTPConfig(
    organizationId: string,
    workspaceId: string,
    $config?: KyOptions,
  ): Promise<Record<string, unknown>> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/configs/smtp`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * Retrieves all worker groups in the workspace
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   */
  getWorkspaceWorkergroups(organizationId: string, workspace: string, $config?: KyOptions): Promise<WorkerGroups> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/workergroups`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<WorkerGroups>();
  },

  /**
   * Retrieves all worker groups in the workspace by id
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param workergroup - Workergroup name (ie. default)
   */
  getWorkspaceWorkergroupsById(
    organizationId: string,
    workspace: string,
    workergroup: string,
    $config?: KyOptions,
  ): Promise<WorkerGroup> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/workergroups/${encodeURIComponent(`${workergroup}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<WorkerGroup>();
  },

  /**
   * Retrieves all workspaces in the organization
   * @param organizationId - Organization Identifier
   */
  getWorkspaces(organizationId: string, $config?: KyOptions): Promise<Workspaces> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Workspaces>();
  },

  /**
   * Issues a provision command to Cribl Leader to provision Worker Group resources
   * @param body
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param workergroup - Workergroup name (ie. default)
   */
  provisionWorkerGroupResources(
    body: WorkerGroupOperation,
    organizationId: string,
    workspace: string,
    workergroup: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/workergroups/${encodeURIComponent(`${workergroup}`)}/operations`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<unknown>();
  },

  /**
   * Requested a new workspace for provisioning
   * @param body
   * @param organizationId - Organization Identifier
   */
  provisionWorkspace(
    body: {alias: string; description?: string; region: string; tags?: string[]; workspaceId: string},
    organizationId: string,
    $config?: KyOptions,
  ): Promise<Workspace> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<Workspace>();
  },

  /**
   * @param body
   * @param organizationId - Organization Identifier
   * @param workspaceId - Workspace unique identifier
   */
  updateInsightsDataRetention(
    body: {days: 2 | 7 | 30 | 90 | 365},
    organizationId: string,
    workspaceId: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/insightsDataRetention`;

    return getKyHttp().patch(url, {
      json: body,
      ...$config,
    });
  },

  /**
   * Update the workspace and return the updated workspace
   * @param body
   * @param organizationId - Organization Identifier
   * @param workspaceId - Workspace unique identifier
   */
  updateWorkspaceById(
    body: {alias?: string; description?: string; tags?: string[]},
    organizationId: string,
    workspaceId: string,
    $config?: KyOptions,
  ): Promise<Workspace> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}`;

    return getKyHttp()
      .patch(url, {
        json: body,
        ...$config,
      })
      .json<Workspace>();
  },

  /**
   * Update a worker group's PrivateLink configuration
   * @param body
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   * @param workergroup - Workergroup name (ie. default)
   */
  updateWorkspaceWorkergroupsById(
    body: UpdateWorkerGroupRequest,
    organizationId: string,
    workspace: string,
    workergroup: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/workergroups/${encodeURIComponent(`${workergroup}`)}`;

    return getKyHttp().patch(url, {
      json: body,
      ...$config,
    });
  },
};

export const deploymentsClient = {
  /**
   * Get Auth Token for connected deployment
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   */
  getWorkspaceConnectedDeploymentAuthToken(
    organizationId: string,
    workspace: string,
    $config?: KyOptions,
  ): Promise<string> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/connected-deployments/auth-token`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<string>();
  },

  /**
   * Get all connected deployments for a workspace
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   */
  listWorkspaceConnectedDeployments(
    organizationId: string,
    workspace: string,
    $config?: KyOptions,
  ): Promise<ListWorkspaceConnectedDeploymentsResponse> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/connected-deployments`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<ListWorkspaceConnectedDeploymentsResponse>();
  },
};

export const defaultClient = {
  /**
   * Delete a release build (idempotent)
   * @param channel - release-channel name
   * @param buildId - release build identifier
   */
  deleteReleaseBuild(channel: string, buildId: string, $config?: KyOptions): Promise<unknown> {
    const url = `system/release-channels/${encodeURIComponent(`${channel}`)}/builds/${encodeURIComponent(`${buildId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Fetch a single release build
   * @param summary (optional) - When "true", returns the trimmed ReleaseBuildSummary (omits packer manifests).
   * @param channel - release-channel name
   * @param buildId - release build identifier
   */
  getReleaseBuild(
    summary: 'true' | null | undefined,
    channel: string,
    buildId: string,
    $config?: KyOptions,
  ): Promise<ReleaseBuildSummary> {
    const url = `system/release-channels/${encodeURIComponent(`${channel}`)}/builds/${encodeURIComponent(`${buildId}`)}`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          summary: summary,
        }),
        ...$config,
      })
      .json<ReleaseBuildSummary>();
  },

  /**
   * Retrieve the workspace's PrivateLink configuration
   * @param includeWorkerGroups (optional) - When true, include PrivateLink configuration details for every worker group in the workspace.
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   */
  getWorkspacePrivateLink(
    includeWorkerGroups: boolean | null | undefined,
    organizationId: string,
    workspace: string,
    $config?: KyOptions,
  ): Promise<WorkspacePrivateLink> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/privatelink`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          includeWorkerGroups: includeWorkerGroups,
        }),
        ...$config,
      })
      .json<WorkspacePrivateLink>();
  },

  /**
   * List release builds on a channel, newest first
   * @param queryParams (optional) - Grouped query parameters object (latest, summary)
   * @param channel - release-channel name
   */
  listReleaseBuilds(
    queryParams: {latest?: 'true' | null; summary?: 'true' | null} | null | undefined,
    channel: string,
    $config?: KyOptions,
  ): Promise<ListReleaseBuildsSummaryResult> {
    const url = `system/release-channels/${encodeURIComponent(`${channel}`)}/builds`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          latest: queryParams?.latest,
          summary: queryParams?.summary,
        }),
        ...$config,
      })
      .json<ListReleaseBuildsSummaryResult>();
  },

  /**
   * List workspaces with an override for (component, componentChannel) — paginated
   * @param queryParams (optional) - Grouped query parameters object (cursor, pageSize)
   * @param component - component identifier
   * @param componentChannel - component channel identifier
   */
  listWorkspacesByComponentOverride(
    queryParams: {cursor?: string | null; pageSize?: number | null} | null | undefined,
    component: string,
    componentChannel: string,
    $config?: KyOptions,
  ): Promise<Record<string, unknown>> {
    const url = `system/components/${encodeURIComponent(`${component}`)}/channels/${encodeURIComponent(`${componentChannel}`)}/workspaces`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          cursor: queryParams?.cursor,
          pageSize: queryParams?.pageSize,
        }),
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * List workspaces subscribed to a release channel (paginated)
   * @param queryParams (optional) - Grouped query parameters object (cursor, pageSize)
   * @param channel - release-channel name
   */
  listWorkspacesByReleaseChannel(
    queryParams: {cursor?: string | null; pageSize?: number | null} | null | undefined,
    channel: string,
    $config?: KyOptions,
  ): Promise<Record<string, unknown>> {
    const url = `system/release-channels/${encodeURIComponent(`${channel}`)}/workspaces`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          cursor: queryParams?.cursor,
          pageSize: queryParams?.pageSize,
        }),
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * Update the workspace's PrivateLink configuration
   * @param body
   * @param organizationId - Organization Identifier
   * @param workspace - Workspace name (ie. main)
   */
  updateWorkspacePrivateLink(
    body: UpdateWorkspacePrivateLinkRequest,
    organizationId: string,
    workspace: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspace}`)}/privatelink`;

    return getKyHttp().patch(url, {
      json: body,
      ...$config,
    });
  },
};

export const searchFleetsClient = {
  /**
   * List instances in a search fleet
   * Retrieves all instances for the specified search fleet
   * @param organizationId - Organization Identifier
   * @param workspaceId - Workspace Identifier
   * @param type - Deployment type
   * @param name - Search fleet identifier
   */
  getSearchFleetInstances(
    organizationId: string,
    workspaceId: string,
    type: 'search',
    name: string,
    $config?: KyOptions,
  ): Promise<DescribeInstancesResponse> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/deployments/${encodeURIComponent(`${type}`)}/${encodeURIComponent(`${name}`)}/instances`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<DescribeInstancesResponse>();
  },

  /**
   * List search fleets
   * Retrieves fleet details for the workspace. Optionally filter by cloud provider or region using query parameters.
   * @param organizationId - Organization Identifier
   * @param workspaceId - Workspace Identifier
   * @param type - Deployment type
   * @param queryParams (optional) - Grouped query parameters object (provider, region)
   */
  getSearchFleets(
    organizationId: string,
    workspaceId: string,
    type: 'search',
    queryParams?: {provider?: 'AZURE' | 'AWS' | 'GCP' | null; region?: string | null} | null,
    $config?: KyOptions,
  ): Promise<DescribeFleetsResponse> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/deployments/${encodeURIComponent(`${type}`)}/fleets`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          provider: queryParams?.provider,
          region: queryParams?.region,
        }),
        ...$config,
      })
      .json<DescribeFleetsResponse>();
  },

  /**
   * Operate on search fleet instances
   * Perform an operation on VM instances in a search fleet. Use 'start' to power on, 'stop' to deallocate, or 'terminate' to permanently delete instances.
   * @param body
   * @param organizationId - Organization Identifier
   * @param workspaceId - Workspace Identifier
   * @param type - Deployment type
   * @param name - Search fleet identifier
   */
  operateSearchFleetInstances(
    body: OperateInstancesRequest,
    organizationId: string,
    workspaceId: string,
    type: 'search',
    name: string,
    $config?: KyOptions,
  ): Promise<OperationInstancesResponse> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/deployments/${encodeURIComponent(`${type}`)}/${encodeURIComponent(`${name}`)}/operations`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<OperationInstancesResponse>();
  },

  /**
   * Update search fleet capacity
   * Updates target capacity for a search fleet. Only capacity increases are allowed; decreases are rejected to prevent accidental data loss.
   * @param body
   * @param organizationId - Organization Identifier
   * @param workspaceId - Workspace Identifier
   * @param type - Deployment type
   * @param name - Search fleet identifier
   */
  updateSearchFleet(
    body: UpdateFleetCapacityRequest,
    organizationId: string,
    workspaceId: string,
    type: 'search',
    name: string,
    $config?: KyOptions,
  ): Promise<ModifyFleetResponse> {
    const url = `organizations/${encodeURIComponent(`${organizationId}`)}/workspaces/${encodeURIComponent(`${workspaceId}`)}/deployments/${encodeURIComponent(`${type}`)}/${encodeURIComponent(`${name}`)}`;

    return getKyHttp()
      .put(url, {
        json: body,
        ...$config,
      })
      .json<ModifyFleetResponse>();
  },
};

export const systemClient = {
  /**
   * Add system role to a user
   * @param body
   * @param userId - User Identifier
   */
  addSystemRoleToUser(
    body: AddSystemRoleToUserRequest,
    userId: string,
    $config?: KyOptions,
  ): Promise<AddSystemRoleToUserResponse> {
    const url = `system/users/${encodeURIComponent(`${userId}`)}/roles`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<AddSystemRoleToUserResponse>();
  },

  /**
   * Get system roles/permissions access report for user
   * @param body
   */
  checkSystemAccess(body: SystemAccessCheckRequest, $config?: KyOptions): Promise<SystemAccessCheckResponse> {
    const url = `system/access`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<SystemAccessCheckResponse>();
  },

  /**
   * Remove an organization member from the org leader (membership sync)
   * @param organizationId - Organization Identifier
   * @param userId - User Identifier
   */
  deleteOrganizationMemberFromLeader(organizationId: string, userId: string, $config?: KyOptions): Promise<unknown> {
    const url = `system/organizations/${encodeURIComponent(`${organizationId}`)}/members/${encodeURIComponent(`${userId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Retrieve available login connections by organization for the provided email
   * @param email
   * @param authorization (API name: Authorization) - Bearer verification token for this email
   */
  getLoginOptions(email: string, authorization: string, $config?: KyOptions): Promise<LoginOptionsResponse> {
    const url = `system/login-options`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          email: email,
        }),
        headers: {
          Authorization: authorization ?? undefined,
        },
        ...$config,
      })
      .json<LoginOptionsResponse>();
  },

  /**
   * List system roles for a user
   * @param userId - User Identifier
   */
  listSystemRolesByUser(userId: string, $config?: KyOptions): Promise<ListSystemRolesByUserResponse> {
    const url = `system/users/${encodeURIComponent(`${userId}`)}/roles`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<ListSystemRolesByUserResponse>();
  },

  /**
   * Resolve next login action and optionally trigger OTC challenge
   * @param body
   */
  preLogin(body: PreLoginRequest, $config?: KyOptions): Promise<PreLoginResponse> {
    const url = `system/pre-login`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<PreLoginResponse>();
  },

  /**
   * Exchange OTC verification code for login token
   * @param body
   */
  preLoginToken(body: PreLoginTokenRequest, $config?: KyOptions): Promise<PreLoginTokenResponse> {
    const url = `system/pre-login-token`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<PreLoginTokenResponse>();
  },

  /**
   * Remove system role from a user
   * @param body
   * @param userId - User Identifier
   */
  removeSystemRoleFromUser(
    body: RemoveSystemRoleFromUserRequest,
    userId: string,
    $config?: KyOptions,
  ): Promise<RemoveSystemRoleFromUserResponse> {
    const url = `system/users/${encodeURIComponent(`${userId}`)}/roles`;

    return getKyHttp()
      .delete(url, {
        json: body,
        ...$config,
      })
      .json<RemoveSystemRoleFromUserResponse>();
  },

  /**
   * Reconcile organization members with the org leader (membership sync)
   * @param organizationId - Organization Identifier
   */
  syncOrganizationMembersFromLeader(organizationId: string, $config?: KyOptions): Promise<Record<string, unknown>> {
    const url = `system/organizations/${encodeURIComponent(`${organizationId}`)}/members/sync`;

    return getKyHttp()
      .post(url, {
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * Upsert an organization member from the org leader (membership sync)
   * @param body
   * @param organizationId - Organization Identifier
   * @param userId - User Identifier
   */
  upsertOrganizationMemberFromLeader(
    body: SyncMemberRequest,
    organizationId: string,
    userId: string,
    $config?: KyOptions,
  ): Promise<SyncMemberResponse> {
    const url = `system/organizations/${encodeURIComponent(`${organizationId}`)}/members/${encodeURIComponent(`${userId}`)}`;

    return getKyHttp()
      .put(url, {
        json: body,
        ...$config,
      })
      .json<SyncMemberResponse>();
  },
};

export const componentsClient = {
  /**
   * Register a new component build on a channel
   * @param body
   * @param component - component identifier (e.g. stream)
   * @param componentChannel - component channel name
   */
  createComponentBuild(
    body: Record<string, unknown>,
    component: string,
    componentChannel: string,
    $config?: KyOptions,
  ): Promise<Record<string, unknown>> {
    const url = `system/components/${encodeURIComponent(`${component}`)}/channels/${encodeURIComponent(`${componentChannel}`)}/builds`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * Delete a component build (idempotent)
   * @param component - component identifier
   * @param componentChannel - component channel name
   * @param buildId - build identifier
   */
  deleteComponentBuild(
    component: string,
    componentChannel: string,
    buildId: string,
    $config?: KyOptions,
  ): Promise<unknown> {
    const url = `system/components/${encodeURIComponent(`${component}`)}/channels/${encodeURIComponent(`${componentChannel}`)}/builds/${encodeURIComponent(`${buildId}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Fetch a component build by id
   * @param component - component identifier
   * @param componentChannel - component channel name
   * @param buildId - build identifier
   */
  getComponentBuild(
    component: string,
    componentChannel: string,
    buildId: string,
    $config?: KyOptions,
  ): Promise<Record<string, unknown>> {
    const url = `system/components/${encodeURIComponent(`${component}`)}/channels/${encodeURIComponent(`${componentChannel}`)}/builds/${encodeURIComponent(`${buildId}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * List component builds on a channel
   * @param latest (optional) - when 'true', collapses items to the channel marker's latest build
   * @param component - component identifier (e.g. stream)
   * @param componentChannel - component channel name
   */
  listComponentBuilds(
    latest: string | null | undefined,
    component: string,
    componentChannel: string,
    $config?: KyOptions,
  ): Promise<Record<string, unknown>> {
    const url = `system/components/${encodeURIComponent(`${component}`)}/channels/${encodeURIComponent(`${componentChannel}`)}/builds`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          latest: latest,
        }),
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * List all channels carrying a build for a component
   * @param component - component identifier
   */
  listComponentChannels(component: string, $config?: KyOptions): Promise<ComponentChannel[]> {
    const url = `system/components/${encodeURIComponent(`${component}`)}/channels`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<ComponentChannel[]>();
  },
};

export const productBuildsClient = {
  /**
   * Creates a product build
   * @param body
   */
  createProductBuild(body: ProductBuild, $config?: KyOptions): Promise<Record<string, unknown>> {
    const url = `system/productbuilds`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * Deletes a product build
   * @param queryParams - Grouped query parameters object (channel, version, build)
   */
  deleteProductBuild(
    queryParams: {channel: string; version: string; build: string},
    $config?: KyOptions,
  ): Promise<Record<string, unknown>> {
    const url = `system/productbuilds`;

    return getKyHttp()
      .delete(url, {
        searchParams: encodeParams({
          channel: queryParams?.channel,
          version: queryParams?.version,
          build: queryParams?.build,
        }),
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * Resolves a product build subscription
   * @param queryParams - Grouped query parameters object (channel, version, build)
   */
  getLatestProductBuild(
    queryParams: {channel: string; version: string; build?: string | null},
    $config?: KyOptions,
  ): Promise<ProductBuild> {
    const url = `system/productbuilds`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          channel: queryParams?.channel,
          version: queryParams?.version,
          build: queryParams?.build,
        }),
        ...$config,
      })
      .json<ProductBuild>();
  },

  /**
   * Lists all builds on a release channel
   * @param channel - release channel
   * @param version - partial or complete semantic version
   * @param build (optional) - build id to inspect
   */
  listAllChannelProductBuilds(
    channel: string,
    version: string,
    build?: string | null,
    $config?: KyOptions,
  ): Promise<ProductBuild[]> {
    const url = `system/productbuilds/${encodeURIComponent(`${channel}`)}/${encodeURIComponent(`${version}`)}`;

    return getKyHttp()
      .get(url, {
        searchParams: encodeParams({
          build: build,
        }),
        ...$config,
      })
      .json<ProductBuild[]>();
  },

  /**
   * Lists all workspaces on a release channel
   * @param channel - release channel
   */
  listProductBuildSubscriptions(channel: string, $config?: KyOptions): Promise<Record<string, unknown>> {
    const url = `system/productbuilds/${encodeURIComponent(`${channel}`)}/workspaces`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * Patches a product build
   * @param body
   */
  updateProductBuild(body: ProductBuild, $config?: KyOptions): Promise<Record<string, unknown>> {
    const url = `system/productbuilds`;

    return getKyHttp()
      .patch(url, {
        json: body,
        ...$config,
      })
      .json<Record<string, unknown>>();
  },
};

export const releaseChannelsClient = {
  /**
   * Create a release-channel config
   * @param body
   */
  createReleaseChannelConfig(body: Record<string, unknown>, $config?: KyOptions): Promise<Record<string, unknown>> {
    const url = `system/release-channels`;

    return getKyHttp()
      .post(url, {
        json: body,
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * Delete a release-channel config (idempotent)
   * @param channel - release-channel name (e.g. ga, rd, stage-default)
   */
  deleteReleaseChannelConfig(channel: string, $config?: KyOptions): Promise<unknown> {
    const url = `system/release-channels/${encodeURIComponent(`${channel}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Fetch a single release-channel config
   * @param channel - release-channel name (e.g. ga, rd, stage-default)
   */
  getReleaseChannelConfig(channel: string, $config?: KyOptions): Promise<ReleaseChannelConfig> {
    const url = `system/release-channels/${encodeURIComponent(`${channel}`)}`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<ReleaseChannelConfig>();
  },

  /** List every release-channel config */
  listReleaseChannelConfigs($config?: KyOptions): Promise<ReleaseChannelConfig[]> {
    const url = `system/release-channels`;

    return getKyHttp()
      .get(url, {
        ...$config,
      })
      .json<ReleaseChannelConfig[]>();
  },

  /**
   * Partial update of a release-channel config
   * @param body
   * @param channel - release-channel name (e.g. ga, rd, stage-default)
   */
  patchReleaseChannelConfig(
    body: Record<string, unknown>,
    channel: string,
    $config?: KyOptions,
  ): Promise<Record<string, unknown>> {
    const url = `system/release-channels/${encodeURIComponent(`${channel}`)}`;

    return getKyHttp()
      .patch(url, {
        json: body,
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * Remove a component subscription from a channel
   * @param channel - release-channel name
   * @param component - component name being subscribed
   */
  removeReleaseChannelSubscription(channel: string, component: string, $config?: KyOptions): Promise<unknown> {
    const url = `system/release-channels/${encodeURIComponent(`${channel}`)}/subscriptions/${encodeURIComponent(`${component}`)}`;

    return getKyHttp().delete(url, {
      ...$config,
    });
  },

  /**
   * Set or change a component subscription on a channel
   * @param body
   * @param channel - release-channel name
   * @param component - component name being subscribed
   */
  setReleaseChannelSubscription(
    body: Record<string, unknown>,
    channel: string,
    component: string,
    $config?: KyOptions,
  ): Promise<Record<string, unknown>> {
    const url = `system/release-channels/${encodeURIComponent(`${channel}`)}/subscriptions/${encodeURIComponent(`${component}`)}`;

    return getKyHttp()
      .put(url, {
        json: body,
        ...$config,
      })
      .json<Record<string, unknown>>();
  },

  /**
   * Fire the release-build evaluator for a single channel
   * @param channel - release-channel name
   */
  triggerReleaseChannel(channel: string, $config?: KyOptions): Promise<Record<string, unknown>> {
    const url = `system/release-channels/${encodeURIComponent(`${channel}`)}/trigger`;

    return getKyHttp()
      .post(url, {
        ...$config,
      })
      .json<Record<string, unknown>>();
  },
};

export const usersClient = {
  /**
   * Sends a verification email for user's Auth0 account
   * @param userId - User Identifier
   */
  createUserVerificationEmail(userId: string, $config?: KyOptions): Promise<unknown> {
    const url = `users/${encodeURIComponent(`${userId}`)}/verification-email`;

    return getKyHttp().post(url, {
      ...$config,
    });
  },

  /**
   * Update current user's profile metadata in Auth0
   * @param body
   * @param userId - User Identifier
   */
  updateProfile(body: UpdateProfileRequest, userId: string, $config?: KyOptions): Promise<unknown> {
    const url = `users/${encodeURIComponent(`${userId}`)}/profile`;

    return getKyHttp().put(url, {
      json: body,
      ...$config,
    });
  },

  /**
   * Record the current user's onboarding metadata and survey results
   * Publishes the intent survey to Segment and persists the onboarding metadata. For org-centric identity orgs the metadata is not persisted (the org leader owns the user record) and the response echoes the request.
   * @param body
   * @param userId - User Identifier
   */
  updateProfileOnboarding(
    body: UpdateProfileOnboardingRequest,
    userId: string,
    $config?: KyOptions,
  ): Promise<UpdateProfileOnboardingResponse> {
    const url = `users/${encodeURIComponent(`${userId}`)}/profile/onboarding`;

    return getKyHttp()
      .patch(url, {
        json: body,
        ...$config,
      })
      .json<UpdateProfileOnboardingResponse>();
  },
};

/**
 * Serializes a params object into a query string that is compatible with different REST APIs.
 * Implementation from: https://github.com/suhaotian/xior/blob/main/src/utils.ts
 * Kudos to @suhaotian for the original implementation
 */
function _encodeParams<T = any>(
  params: T,
  parentKey: string | null = null,
  options?: {
    allowDots?: boolean;
    serializeDate?: (value: Date) => string;
    arrayFormat?: 'indices' | 'repeat' | 'brackets';
  },
): string {
  if (params === undefined || params === null) return '';
  const encodedParams: string[] = [];
  const paramsIsArray = Array.isArray(params);
  const {arrayFormat, allowDots, serializeDate} = options || {};

  const getKey = (key: string) => {
    if (allowDots && !paramsIsArray) return `.${key}`;
    if (paramsIsArray) {
      if (arrayFormat === 'brackets') {
        return '[]';
      }
      if (arrayFormat === 'repeat') {
        return '';
      }
    }
    return `[${key}]`;
  };

  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      let value = (params as any)[key];
      if (value !== undefined) {
        const encodedKey = parentKey ? `${parentKey}${getKey(key)}` : (key as string);

        // biome-ignore lint/suspicious/noGlobalIsNan: <explanation>
        if (!isNaN(value) && value instanceof Date) {
          value = serializeDate ? serializeDate(value) : value.toISOString();
        }
        if (typeof value === 'object') {
          // If the value is an object or array, recursively encode its contents
          const result = _encodeParams(value, encodedKey, options);
          if (result !== '') encodedParams.push(result);
        } else {
          // Otherwise, encode the key-value pair
          encodedParams.push(`${encodeURIComponent(encodedKey)}=${encodeURIComponent(value)}`);
        }
      }
    }
  }

  return encodedParams.join('&');
}

/** Serializes a params object into a query string. Options override the generated defaults (allowDots, arrayFormat). */
export function encodeParams<T = any>(
  params: T,
  parentKey: string | null = null,
  options?: {
    allowDots?: boolean;
    serializeDate?: (value: Date) => string;
    arrayFormat?: 'indices' | 'repeat' | 'brackets';
  },
): string {
  return _encodeParams(params, parentKey, {
    allowDots: true,
    arrayFormat: 'repeat',
    ...options,
  });
}
export enum AccountState {
  AccountProv = 'Account-Prov',
  AccountReady = 'Account-Ready',
  TerraformProv = 'Terraform-Prov',
  PreProv = 'Pre-Prov',
  PostProv = 'Post-Prov',
  TenantReady = 'Tenant-Ready',
  TenantAssigned = 'Tenant-Assigned',
  TenantUnassigned = 'Tenant-Unassigned',
  CleanupRequested = 'Cleanup-Requested',
  CleanupStarted = 'Cleanup-Started',
  CleanupCompleted = 'Cleanup-Completed',
  CleanupFailed = 'Cleanup-Failed',
  AccountAvailable = 'Account-Available',
  TenantFailed = 'Tenant-Failed',
  TenantFailedDLQ = 'Tenant-FailedDLQ',
  TenantBanished = 'Tenant-Banished',
  WorkspaceRequested = 'Workspace-Requested',
  WorkspaceProvisioning = 'Workspace-Provisioning',
  WorkspaceProvisioningFailed = 'Workspace-Provisioning-Failed',
  WorkspaceProvisioned = 'Workspace-Provisioned',
  WorkspaceActive = 'Workspace-Active',
  WorkspaceAsleep = 'Workspace-Asleep',
  WorkspaceAsleepRequested = 'Workspace-Asleep-Requested',
  WorkspaceWakeRequested = 'Workspace-Wake-Requested',
  WorkspaceUpdated = 'Workspace-Updated',
  WorkspaceFailedUpdate = 'Workspace-Failed-Update',
  WorkspaceCleanupRequested = 'Workspace-Cleanup-Requested',
  WorkspaceCleanupStarted = 'Workspace-Cleanup-Started',
  WorkspaceCleanupTerraformCompleted = 'Workspace-Cleanup-Terraform-Completed',
  WorkspaceCleanupTerraformFailed = 'Workspace-Cleanup-Terraform-Failed',
  WorkspaceCleanupCompleted = 'Workspace-Cleanup-Completed',
  WorkspaceCleanupFailed = 'Workspace-Cleanup-Failed',
}

export type AddSystemRoleToUserRequest = {
  roles: SystemRole[];
};

export type AddSystemRoleToUserResponse = {
  /** The user's complete set of system roles after the requested roles were added. */
  roles: SystemRole[];
};

export type AiArtifacts = Record<string, string>;

export type AjvError = {
  errors: Record<string, unknown>[];
};

/** Represents an Audit Log of an event that occurred in the system */
export type AuditLog = {
  /** The type of action performed */
  action?: string;
  /** The auth log event channel */
  channel?: string;
  /** An identifier for the log entry */
  id?: string;
  /** Additional metadata about the action */
  metadata?: unknown;
  /** The organization that the log applies to */
  organization?: string;
  /** The ID of the user that the action pertains to */
  principal?: string;
  /** The system that generated the auth log */
  provider?: string;
  /** The ID of the user that performed the action */
  requestor?: string;
  /** Whether the action succeeded or failed */
  result?: string;
  /** The upstream system the event originated from */
  src?: string;
  /** The identifier of the resource that was affected by the action */
  targetResource?: string;
  /** The name of the resource that was affected by the action */
  targetResourceName?: string;
  /** The type of resource that was affected by the action */
  targetResourceType?: string;
  /** A UTC date representing when the logged action occurred */
  timestamp?: string;
  /** The user agent from the user who performed the action */
  userAgent?: string;
  /** The workspace that the log applies to */
  workspace?: string;
};

export type AuditLogForwardingConfig = {
  /** Whether the forwarding config is associated with an auth token */
  hasAuthToken?: boolean;
  /** Whether the forwarding endpoint uses HTTPS */
  https: boolean;
  /** An identifier for the forwarding config */
  id: string;
  /** The organization to which the forwarding config applies */
  organization: string;
  /** The path for the forwarding endpoint */
  path: string;
  /** The port number for the forwarding endpoint */
  port: number;
  /** Whether the forwarding config is using the Cribl HTTP source */
  useCriblHTTPSource?: boolean;
  /** The worker group that the config should be forwarded to */
  workerGroupName: string;
  /** The workspace that the config should be forwarded to */
  workspace: string;
};

export type AwsRegionToAmiMap = Record<string, unknown>;

export type AzureImage = {
  ManagedImageSharedImageGalleryId?: string;
  SharedImageGalleryImageName: string;
  SharedImageGalleryImageVersion?: string;
  SharedImageGalleryName?: string;
  SharedImageGalleryResourceGroup?: string;
};

export type BadRequestError = {
  code: string;
  message: string;
};

/** Represents a client in the system */
export type Client = {
  /** The name of the client assigned by the user */
  clientAssignedName: string;
  /** The client ID of the client */
  clientId: string;
  /** The client secret of the client. Only present on create responses. */
  clientSecret?: string;
  /**
   * The email address of the creator of the client
   * @format email
   */
  createdBy: string;
  /** The date the client was created */
  createdDate: string;
  /** The role of the creator of the client */
  creatorRole: string;
  /** The description of the client */
  description?: string;
  /** Whether the client is enabled or not */
  enabled: boolean;
  /** Grants given to the client, admin api only */
  grants?: {audience?: string; clientId?: string; grantId?: string; scope?: string}[];
  /** CIDR ranges from which the API client can make requests */
  ipAllowlist?: string[];
  /**
   * The email address of the last user to update the client
   * @format email
   */
  lastUpdatedBy: string;
  /** The date the client was last updated */
  lastUpdatedDate: string;
  /** The Cribl name of the client inc prefixes/suffixes */
  name?: string;
  /** The organization ID the client belongs to */
  organizationId: string;
  /** Product level roles assigned to the client per workspace */
  productRoles: {product?: string; role?: string; workspaceName?: string}[];
  /** Organization level role assigned to the client */
  role: string;
  /** Whether this is a system-managed client */
  system: boolean;
  /** The workspace this client is scoped to */
  workspaceName: string;
  /** Workspace level roles assigned to the client */
  workspaceRoles: {role?: string; workspaceName?: string}[];
};

export type ClientCreate = Client & Required<Pick<Client, 'role' | 'clientAssignedName'>>;

export type ClientUpdate = Client;

export type CloudProviderInstanceHeader = {
  id: string;
  kind: 'AZURE' | 'AWS' | 'GCP';
  providerId: string;
};

/** A channel that carries a build for a given component. */
export type ComponentChannel = {
  /** The component identifier. */
  component: string;
  /** The component channel identifier. */
  componentChannel: string;
  /** The id of the latest build available on this component channel. */
  latestBuildId?: string;
  /** Human-readable tag of the latest build's artifact, when the build pipeline records one. Absent on markers that predate the field. */
  latestTag?: string;
  /** Epoch seconds of the channel marker's last update, i.e. when the latest build landed on this channel. Absent on markers that predate the field. */
  updatedAt?: number;
};

/** Represents a Connected Deployment in the workspace */
export type ConnectedDeployment = {
  /** The name of the Connected Deployment */
  deploymentId: string;
  /** The hostname of the Connected Deployment */
  hostname: string;
  /** The ID/GUID of the Connected Deployment */
  id: string;
  /** timestamp of last heart beat message from Connected Deployment */
  lastHeartbeat: number;
  /** the status of the Connected Deployment */
  status: string;
};

export type Connection = OIDCConnection | SAMLConnection;

/** the kind of the connection (OIDC, SAML) */
export enum ConnectionKind {
  OIDC = 'OIDC',
  SAML = 'SAML',
}

export type CreateAuditLogForwardingConfigRequest = {
  /** Token to be used in the Authorization header on forwarded requests */
  authToken?: string;
  /** Whether the forwarding endpoint uses HTTPS */
  https: boolean;
  /** The path for the forwarding endpoint */
  path: string;
  /** The port number for the forwarding endpoint */
  port: number;
  /** The worker group that the config should be forwarded to */
  workerGroupName: string;
  /** The workspace that the config should be forwarded to */
  workspace: string;
};

export type CreateOIDCConnectionRequest = {
  /** a flag to avoid mapping a domain to the new SSO connection */
  bypassDomainMapping?: boolean;
  /** client ID as provided by the identity provider */
  clientId: string;
  /** client secret as provided by the identity provider */
  clientSecret: string;
  /** optional string for the SSO domain that an SE can pass in when assisting a customer */
  domain?: string;
  /** optionally manually configure endpoints instead of using discovery */
  endpoints?: {authorization: string; jwks: string; token: string; userInfo?: string | null};
  /** optional string to determine how to map groups from the Identity Provider to Cribl.Cloud. */
  groupMapVal?: string;
  /** where to find IDP groups information */
  groupsSource?: 'user_info' | 'id_token_claims';
  /** issuer url as provided by the identity provider */
  issuerUrl: string;
  /** indicates that the type of connection being created is OIDC */
  kind: 'OIDC';
  /** scopes as provided by the identity provider */
  scopes?: string;
};

export type CreateSAMLConnectionRequest = {
  /** a flag to avoid mapping a domain to the new SSO connection */
  bypassDomainMapping?: boolean;
  /** optional string for the SSO domain that an SE can pass in when assisting a customer */
  domain?: string;
  /** an issuer URL provided by the originating identity provider */
  identityProviderIssuer: string;
  /** indicates that the type of connection being created is SAML */
  kind: 'SAML';
  /** a single sign on URL provided by the originating identity provider */
  singleSignOnUrl: string;
  /** a certificate issued by the originating identity provider */
  x509Certificate: string;
};

export type DescribeFleetsResponse = {
  /** List of fleets */
  fleets: Fleet[];
};

export type DescribeInstancesResponse = {
  /** List of fleet instances */
  instances: FleetInstance[];
};

export type Error = {
  /** an internal code for the error */
  code: string;
  /** a message explaining the reason for the error */
  message: string;
};

export type Fleet = {
  capacity: FleetCapacity;
  /**
   * Timestamp when the fleet was created
   * @format date-time
   */
  createdAt?: string;
  /** Unique identifier for the fleet */
  id: string;
  /** Name of the fleet */
  name: string;
  /** Cloud provider for the fleet */
  provider: 'AZURE' | 'AWS' | 'GCP';
  /** Geographic region of the fleet */
  region: string;
  /** Current state of the fleet */
  state: ResourceState;
};

export type FleetCapacity = {
  /** Target number of instances in the fleet */
  capacity: number;
  /** Maximum number of instances in the fleet */
  max?: number;
  /** Minimum number of instances in the fleet */
  min?: number;
};

export type FleetInstance = {
  /** Provider-specific failure sub-code (e.g. Azure AllocationFailed). Present only when state is failed. */
  errorCode?: string;
  /** Unique identifier for the instance */
  id: string;
  /** Name of the instance */
  name: string;
  /** Cloud provider for the instance */
  provider: 'AZURE' | 'AWS' | 'GCP';
  /** Geographic region of the instance */
  region: string;
  /** VM size/type of the instance */
  size: string;
  /** Current state of the instance */
  state: ResourceState;
};

export type GetOrganizationResponse = Organization;
export type GetTeamsForMemberResponse = {
  count: number;
  teams: MemberTeamGet[];
};

export type InfraChange = {
  resourceAction: 'sync' | 'created' | 'updated' | 'deleted';
  resourceKind:
    | 'LambdaManager'
    | 'WorkerGroup'
    | 'SearchLambda'
    | 'SearchFleet'
    | 'TenantExec'
    | 'Team'
    | 'TeamMembers'
    | 'FastSearch'
    | 'LocalSearch'
    | 'CriblLakeBucket';
  resourceName: string;
  resourceWorkspace: string;
};

export type InfrastructureConfig = {
  change?: InfraChange;
  kind: InfrastructureKind;
  version: string;
};

export enum InfrastructureKind {
  Terraform = 'terraform',
  CloudwatchExporter = 'cloudwatch-exporter',
}

export type InternalServerError = {
  code: string;
  message: string;
};

export type Invite = {
  created: string;
  creator?: string;
  expiration: string;
  id: string;
  invitationLink?: string;
  needsSignup?: boolean;
  /** @default [] */
  productRoles?: {
    product?: 'edge' | 'search' | 'stream' | 'lake' | 'insights';
    role?: 'product_admin' | 'product_editor' | 'product_reader' | 'product_user' | 'product_noaccess';
    workspaceName?: string;
  }[];
  recipient: string;
  recipientFirstName?: string;
  recipientLastName?: string;
  role: 'org_owner' | 'org_admin' | 'org_iam_admin' | 'org_user' | 'billing_reader';
  sender?: string;
  state: 'sent' | 'accepted' | 'revoked';
  /** @default [] */
  teams?: {teamIds?: string[]; workspaceId?: string}[];
  tenantId: string;
  updated: string;
  /** @default [] */
  workspaceRoles?: {role?: 'ws_owner' | 'ws_admin' | 'ws_user'; workspaceName?: string}[];
};

export type InviteArray = Invite[];
export type LicenseUpgradeRequest = {
  requestedBy: string;
};

export type LicenseUpgradeResponse = {
  message: string;
  organizationId: string;
};

/** The envelope returned by `GET .../builds?summary=true`. `latest=true` collapses `items` to a 0- or 1-element array. */
export type ListReleaseBuildsSummaryResult = {
  /** The release builds, newest first. */
  items: ReleaseBuildSummary[];
  /** True when the items are in summary form. */
  summary: boolean;
  /** True when the server capped the returned list. */
  truncated: boolean;
};

export type ListSystemRolesByUserResponse = {
  count: number;
  items: SystemRole[];
};

export type ListWorkspaceConnectedDeploymentsResponse = {
  count: number;
  items: ConnectedDeployment[];
};

export type LoginConnection = {
  id: string;
  label: string;
  type: string;
};

export type LoginOptionsResponse = {
  organizations: OrganizationLoginOptions[];
};

/** Represents a member in the system */
export type Member = {
  /** The roles of the member */
  allRoles?: Roles[];
  /**
   * The email address of the member
   * @format email
   */
  email: string;
  /** The family name of the member */
  familyName: string;
  /** The given name of the member */
  givenName: string;
  /** If user is SSO */
  isSso?: boolean;
  /**
   * The URL of the member's picture
   * @format uri
   */
  picture?: string;
  roles: Role[];
  /** Account active status */
  status?: string;
  /** The user ID of the member */
  userId: string;
};

export type MemberRoles = {
  orgRole?: string;
  productRoles?: ProductRoles;
  workspaceRoles?: WorkspaceRoles;
};

/** A lightweight reference to a team that a member belongs to */
export type MemberTeamGet = {
  /** The ID of the team */
  id: string;
  /** The id of the organization the team belongs to */
  organizationId: string;
  /** The id of the workspace the team belongs to */
  workspaceId: string;
};

/** Response returned when fleet capacity is successfully updated */
export type ModifyFleetResponse = {
  fleet: Fleet;
};

export type NotFoundError = {
  code: string;
  message: string;
};

export type OEM = {
  customerId: string;
  customerName: string;
  id: string;
};

export type OIDCConnection = {
  /** client ID as provided by the identity provider */
  clientId: string;
  /** client secret as provided by the identity provider */
  clientSecret: string;
  /** optional string for the SSO domain that an SE can pass in when assisting a customer */
  domain?: string;
  /** boolean to indicate if the connection should be enabled */
  enabled?: boolean;
  /** endpoints used to connect to the identity provider */
  endpoints?: {authorization?: string; jwks?: string; token?: string; userInfo?: string | null};
  /** optional string to determine how to map groups from the Identity Provider to Cribl.Cloud. */
  groupMapVal?: string;
  /** where to find IDP groups information */
  groupsSource?: 'user_info' | 'id_token_claims';
  /** the unique ID for this connection */
  id?: string;
  /** issuer url as provided by the identity provider */
  issuerUrl: string;
  /** indicates that the connection type is OIDC */
  kind: 'OIDC';
  /** scopes as provided by the identity provider */
  scopes?: string;
};

export type OperateInstancesRequest = {
  /** Array of instance IDs to operate on (format vmssName/instanceId) */
  instanceIds: string[];
  /** Operation to perform on the instances */
  operationType: 'start' | 'stop' | 'terminate';
};

/** Response returned when instances are operated on (started, stopped, or terminated) successfully */
export type OperationInstancesResponse = {
  /** Array of instances that were operated on */
  instances: FleetInstance[];
};

export enum OperationState {
  Updating = 'UPDATING',
  Success = 'SUCCESS',
  Failed = 'FAILED',
  Cleaning = 'CLEANING',
}

/** Represents an Organization model */
export type Organization = {
  accountId: string;
  azureCloudProviderInstance?: CloudProviderInstanceHeader;
  betaOptIn?: boolean;
  blockInfraUntil?: string;
  capabilities: OrganizationCapabilities;
  created: string;
  error?: string;
  id?: string;
  infrastructure?: OrganizationInfrastructure;
  infrastructureConfig?: InfrastructureConfig;
  license?: 'enterprise' | 'standard';
  marketplaceCustomerId?: string;
  marketplaceProductId?: string;
  marketplaceType?: 'aws';
  /** Effective workspace limit from cloud.workspace.provisioning. Set by GET handlers for Stream UI compatibility. Not an org-config field - use the capability to change limits. */
  maxWorkspaces?: number;
  message?: string;
  metronomeCustomerId?: string;
  oem?: OEM;
  oktaGroupId?: string;
  organizationAlias?: string;
  organizationDescription?: string;
  organizationId: string;
  /** Dedicated Org Leader handoff status. ISO-8601 timestamp while handoff is in flight, or the literal value `dedicated` after cutover. Absent when handoff has not started. */
  orgLeaderHandoff?: string;
  owner?: string;
  region?: string;
  ssoConnectionId?: string;
  state: AccountState;
  updated: string;
};

export type OrganizationCapabilities = {
  /** Org-level limit on the number of CIDR ranges per API credential. */
  'cloud.iam.apiCredentialCidr': {maxCidrRanges: number};
  /** Org-level limit on the number of non-system API client credentials. */
  'cloud.iam.apiCredentials': {maxApiCredentials: number};
  'cloud.iam.eventlogs': {enabled: boolean};
  'cloud.iam.fineGrainedRoles': {enabled: boolean};
  'cloud.iam.sso': {enabled: boolean};
  'cloud.iam.teams': {enabled: boolean};
  /** Org-level quota for System Insights free 48-hour retention slots. */
  'cloud.product.systemInsightsPolicy': {maxNonMainFreeWorkspaces: number};
  'cloud.workspace.multiRegion': {enabled: boolean};
  /** Organization-scoped gate for provisioning additional workspaces. */
  'cloud.workspace.provisioning': {enabled: boolean; maxFreeWorkspaces: number; maxWorkspaces: number};
};

export type OrganizationInfrastructure = {
  change?: InfraChange;
  lockAcquired: string;
  taskCreated: string;
  taskFinished: string;
  taskId: string;
  taskState: OperationState;
};

export type OrganizationLicenseUpgradeRequest = LicenseUpgradeRequest;
export type OrganizationLicenseUpgradeResponse = LicenseUpgradeResponse;
export type OrganizationLoginOptions = {
  authBaseUrl?: string;
  connections: LoginConnection[];
  organizationId: string;
  organizationName?: string;
};

export type OrganizationUpdateCommand = {
  auth0OrganizationId?: string;
  betaOptIn?: boolean;
  blockInfraUntil?: string;
  capabilitiesOverrides?: 'fail' | 'keep' | 'drop';
  error?: string;
  infrastructureConfig?: InfrastructureConfig;
  license?: 'enterprise' | 'standard';
  message?: string;
  metronomeCustomerId?: string;
  organizationAlias?: string;
  organizationDescription?: string;
  organizationId: string;
  owner?: string;
  state?: AccountState;
};

/** An organization role that can be assigned to a member */
export type OrgRole = {
  role?: string;
};

export type PreLoginConnectionAction = {
  action: 'login-with-connection';
  connectionId: string;
  organizationId: string;
};

export type PreLoginOrgLeaderAction = {
  action: 'login-with-org-leader';
  authBaseUrl: string;
  organizationId: string;
};

export type PreLoginOtcChallengeAction = {
  action: 'otc-challenge';
};

export type PreLoginRedirectAction = {
  action: 'redirect';
  destination: 'universal_login';
};

export type PreLoginRequest = {
  /** @format email */
  email: string;
  intent?: 'sandbox-assignment';
};

export type PreLoginResponse =
  PreLoginRedirectAction | PreLoginConnectionAction | PreLoginOtcChallengeAction | PreLoginOrgLeaderAction;

export type PreLoginTokenRequest = {
  code: string;
  /** @format email */
  email: string;
};

export type PreLoginTokenResponse = {
  /** @format int64 */
  expiration: number;
  token: string;
};

export type ProductBuild = {
  aiArtifacts?: AiArtifacts;
  ami?: AwsRegionToAmiMap;
  appPlatformDeployer?: ProductBuildImage;
  architectures?: ProductBuildArchitectures;
  azureImage?: AzureImage;
  azureLakeInventory?: ProductBuildImage;
  build: string;
  channel: string;
  clickhouse?: ProductBuildImage;
  cribl?: ProductBuildImage;
  dsdawsscan?: ProductBuildImage;
  infrastructure?: ProductBuildImage;
  isTest?: boolean;
  productSearchAWS?: ProductSearchAWS;
  productStreamAWS?: ProductStreamAWS;
  quality?: string;
  search?: ProductBuildImage;
  version: string;
};

export type ProductBuildArchitectureImages = {
  azureImage: AzureImage;
};

export type ProductBuildArchitectures = {
  amd64: ProductBuildArchitectureImages;
};

export type ProductBuildImage = {
  digest: string;
  repository: string;
  tag: string;
};

export type ProductRole = {
  product?: string;
  role?: string;
  workspaceName?: string;
};

/** An array of product roles that are assignable to a member */
export type ProductRoles = ProductRole[];
export type ProductSearchAWS = {
  build: string;
  name: string;
  source: 'lambda';
};

export type ProductStreamAWS = {
  build: string;
  name: string;
  source: 'cdn' | 's3';
};

export type ProfileOnboarding = {
  intentSurvey?: SurveyData;
  isOnboardingCardCompleted?: boolean;
  isSourcesOnboardingCardStatus?: 'ELIGIBLE' | 'COMPLETED';
};

export type ProfileUpdateCommand = {
  company?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  privacyAccepted: boolean;
  tosAccepted: boolean;
};

/** A release build in its summary form (`summary=true`): the running build of a channel with per-component tags but without the full packer/artifact manifests. */
export type ReleaseBuildSummary = {
  /** The release build identifier (lexicographically chronological). */
  buildId: string;
  /** The release channel this build belongs to. */
  channel: string;
  /** Map of component name to its summarized build snapshot. */
  components: Record<string, ReleaseBuildSummaryComponent>;
  /** Creation time, epoch seconds. */
  createdAt: number;
  /** Expiry time, epoch seconds (min of the component expiries). */
  expiresAt: number;
};

/** A single component within a release build, as returned by the `summary=true` projection (the per-component `tag` is hoisted to the top level and the heavy `artifact` manifest is omitted). */
export type ReleaseBuildSummaryComponent = {
  /** The component build id this release build pins the component to. */
  buildId: string;
  /** The component channel the build was drawn from. */
  componentChannel: string;
  /** The artifact tag (e.g. image tag) for the component. Present only when the component build carries a string tag. */
  tag?: string;
};

/** A release-channel configuration. */
export type ReleaseChannelConfig = {
  /** Whether subscribed workspaces are automatically orchestrated. */
  autoOrchestrate: boolean;
  /** Components whose new builds advance a subscribed workspace (a subset of the subscription keys). */
  buildOnAdvanceOf: string[];
  /** The release channel name (e.g. ga, rd, stage-default). */
  channel: string;
  /** Human-readable channel description. */
  description: string;
  /** Human-readable channel name. */
  displayName: string;
  /** Discriminator for the persisted entity (RELEASECHANNELCONFIG). */
  entityType: string;
  /** Optional 5-field UTC cron controlling automatic advancement. Absent means the channel is only advanced by a manual trigger. */
  schedule?: string;
  /** Map of component name to the component channel it subscribes to. */
  subscriptions: Record<string, string>;
};

export type RemoveSystemRoleFromUserRequest = {
  roles: SystemRole[];
};

export type RemoveSystemRoleFromUserResponse = {
  /** The user's complete set of system roles after the requested roles were removed. */
  roles: SystemRole[];
};

/** Unified resource state combining provisioning and power states */
export enum ResourceState {
  Pending = 'pending',
  Running = 'running',
  Updating = 'updating',
  Stopping = 'stopping',
  Terminating = 'terminating',
  Stopped = 'stopped',
  Failed = 'failed',
  Unknown = 'unknown',
}

/**
 * A role that can be assigned to a member
 * @deprecated
 */
export type Role = {
  role?: string;
};

/** @deprecated */
export type Roles = {
  /** The roles that can be assigned to a member at the organization level */
  orgRole?: OrgRole[];
  /** The roles that can be assigned to a member at the product level */
  productRoles?: ProductRoles[];
  /** The roles that can be assigned to a member at the workspace level */
  workspaceRoles?: WorkspaceRoles[];
};

export type SAMLConnection = {
  /** the endpoint on the service provider (SP) where the identity provider (IdP) redirects the user's authentication response */
  assertionConsumerServiceUrl?: string;
  /** the intended recipient for the SAML Assertion */
  audienceURI?: string;
  /** optional string for the SSO domain that an SE can pass in when assisting a customer */
  domain?: string;
  /** boolean to indicate if the connection is enabled */
  enabled?: boolean;
  /** a certificate used to encrypt the SAML Assertion sent to the Service Provider (i.e., Cribl) */
  encryptionCertificate?: string;
  /** the unique ID for this connection */
  id?: string;
  /** an issuer URL provided by the originating identity provider */
  identityProviderIssuer?: string;
  /** indicates that the connection type is SAML */
  kind: 'SAML';
  /** a single sign on URL provided by the originating identity provider */
  singleSignOnUrl: string;
  /** a certificate issued by the originating identity provider */
  x509Certificate: string;
};

export type ServiceUnavailableError = {
  code: string;
  message: string;
};

export type SurveyData = {
  criblUseCases: string[];
  hasUsedCriblBefore: boolean | null;
  predictedDestinations: string[];
  predictedOrigins: string[];
  predictedStorage: string[];
};

export type SyncMemberRequest = {
  email: string;
  familyName?: string;
  givenName?: string;
  isSso?: boolean;
  ssoGroups?: string[];
  userId: string;
};

export type SyncMemberResponse = {
  email: string;
  familyName: string;
  givenName: string;
  isSso: boolean;
  /** @format date-time */
  lastUpdated: string;
  ssoGroups: string[];
  userId: string;
};

export type SystemAccessCheckRequest = {
  checks: string[];
};

export type SystemAccessCheckResponse = {
  checks: Record<string, boolean>;
};

/** System roles that can be assigned to a user or client. `cloud_user` is deliberately absent: it is a display-only role with no relation in the FGA model. */
export enum SystemRole {
  CloudAdmin = 'cloud_admin',
  CloudAdminReader = 'cloud_admin_reader',
  CloudBillingReader = 'cloud_billing_reader',
  CloudCicd = 'cloud_cicd',
  CloudDeveloper = 'cloud_developer',
  CloudEntitlementsAdmin = 'cloud_entitlements_admin',
  CloudEntitlementsReader = 'cloud_entitlements_reader',
  CloudPurge = 'cloud_purge',
  CloudRcAdmin = 'cloud_rc_admin',
  CloudSe = 'cloud_se',
  CloudSmtpAdmin = 'cloud_smtp_admin',
  CloudSupport = 'cloud_support',
}

/** Represents a team in the system */
export type Team = {
  /** The description of the team */
  description?: string;
  /** The ID of the team */
  id: string;
  /** The ids of users assigned to the team */
  members: string[];
  /** The name of the team */
  name: string;
  /** The id of the organization a team belongs to */
  organizationId?: string;
  /** The roles of the team */
  roles: string[];
  /** The SSO group IDs of the team */
  ssoGroupIds?: string[];
  /** The id of the workspace a team belongs to */
  workspaceId?: string;
};

/** Request body for creating a new team */
export type TeamCreate = {
  /** The description of the team */
  description: string;
  /** The ids of users to add to the team on creation */
  membersToAdd?: string[];
  /** The name of the team */
  name: string;
  /** The roles of the team */
  roles: string[];
  /** The SSO group IDs of the team */
  ssoGroupIds?: string[];
};

/** Request body for updating an existing team (PATCH semantics) */
export type TeamUpdate = {
  /** The description of the team */
  description?: string;
  /** The ids of users to add to the team */
  membersToAdd?: string[];
  /** The ids of users to remove from the team */
  membersToRemove?: string[];
  /** The name of the team */
  name: string;
  /** The roles of the team */
  roles?: string[];
  /** The SSO group IDs of the team */
  ssoGroupIds?: string[];
};

export type UnauthorizedError = {
  code: string;
  message: string;
};

export type UpdateAuditLogForwardingConfigRequest = {
  /** Token to be used in the Authorization header on forwarded requests */
  authToken?: string | null;
  /** Whether the forwarding endpoint uses HTTPS */
  https?: boolean;
  /** The path for the forwarding endpoint */
  path?: string;
  /** The port number for the forwarding endpoint */
  port?: number;
  /** The worker group that the config should be forwarded to */
  workerGroupName?: string;
  /** The workspace that the config should be forwarded to */
  workspace?: string;
};

export type UpdateConnection = {
  /** Client ID as provided by the identity provider (OIDC) */
  clientId?: string;
  /** Client secret as provided by the identity provider (OIDC) */
  clientSecret?: string;
  /** boolean to indicate if the connection should be enabled */
  enabled: boolean;
  /** Optionally manually configure endpoints instead of using discovery (OIDC) */
  endpoints?: {authorization: string; jwks: string; token: string; userInfo?: string | null};
  /** Optional string to determine how to map groups from the Identity Provider to Cribl.Cloud (OIDC) */
  groupMapVal?: string;
  /** Where to find IDP groups information (OIDC) */
  groupsSource?: 'user_info' | 'id_token_claims';
  /** An issuer URL provided by the originating identity provider (SAML) */
  identityProviderIssuer?: string;
  /** Issuer url as provided by the identity provider (OIDC) */
  issuerUrl?: string;
  /** The kind of connection being updated */
  kind?: ConnectionKind;
  /** Scopes as provided by the identity provider (OIDC) */
  scopes?: string;
  /** A single sign on URL provided by the originating identity provider (SAML) */
  singleSignOnUrl?: string;
  /** A new certificate to update the existing one for SAML connections */
  x509Certificate?: string;
};

export type UpdateFleetCapacityRequest = {
  targetCapacity: FleetCapacity;
};

export type UpdateOrganizationRequest = OrganizationUpdateCommand;
export type UpdateOrganizationResponse = Organization;
export type UpdateProfileOnboardingRequest = ProfileOnboarding;
export type UpdateProfileOnboardingResponse = ProfileOnboarding;
export type UpdateProfileRequest = ProfileUpdateCommand;
/** Partial update for a worker group's PrivateLink configuration. Only fields present in the body are mutated. The PrivateLink DNS name is derived internally and cannot be set via this API. */
export type UpdateWorkerGroupRequest = {
  /** Whether to provision the PrivateLink service for this worker group. */
  createPrivatelink?: boolean;
  /** AWS principals allowed to access the PrivateLink endpoint. Rejected on Azure worker groups. Each entry must be an AWS IAM principal ARN; wildcards are not accepted. */
  privatelinkAllowedPrincipals?: string[];
  /** Azure subscription IDs allowed to access (and auto-approve on) the PrivateLink service. Rejected on AWS worker groups. Each entry must be a subscription UUID. */
  privatelinkAllowedSubscriptionIds?: string[];
};

/** Partial update for a workspace's PrivateLink configuration. Only fields present in the body are mutated. */
export type UpdateWorkspacePrivateLinkRequest = {
  /** Whether to provision the workspace PrivateLink service. */
  createPrivatelink?: boolean;
  /** AWS principals allowed to access the workspace PrivateLink endpoint. Each entry must be an AWS IAM principal ARN; wildcards are not accepted. */
  privatelinkAllowedPrincipals?: string[];
};

/** Invite details returned after successful verifier validation */
export type ValidatedInvite = {
  inviteId: string;
  organizationId: string;
  productRoles: {
    product?: 'edge' | 'search' | 'stream' | 'lake';
    role?: 'product_admin' | 'product_editor' | 'product_reader' | 'product_user' | 'product_noaccess';
    workspaceName?: string;
  }[];
  recipientEmail: string;
  recipientFirstName?: string;
  recipientLastName?: string;
  role: 'org_owner' | 'org_admin' | 'org_iam_admin' | 'org_user' | 'billing_reader';
  teams: {teamIds?: string[]; workspaceId?: string}[];
  workspaceRoles: {role?: 'ws_owner' | 'ws_admin' | 'ws_user'; workspaceName?: string}[];
};

export type WorkerGroup = {
  /** The AWS outbound OIDC issuer URL for this tenant's account, for use as the issuer in an external federated identity credential. Present only on AWS worker groups in commercial environments. */
  awsOutboundOidcIssuer?: string;
  /** The cloud provider hosting this worker group. */
  cloudProviderKind?: 'AWS' | 'AZURE' | 'GCP';
  /** Whether to provision the PrivateLink service for this worker group. Independent of allowlists so clearing an allowlist does not tear the service down. */
  createPrivatelink?: boolean;
  /** Whether cross-zone load balancing is enabled for this worker group. */
  crossZoneLoadBalancing?: boolean;
  /** All addresses that will accept ingress traffic. Use this address for sources that send data. */
  dnsNames: string[];
  /** The provisioned EFS throughput in MiB/s. Only applicable when efsThroughputMode is provisioned. */
  efsThroughputInMibps?: number;
  /** The EFS throughput mode for AWS worker groups using EFS. */
  efsThroughputMode?: 'elastic' | 'provisioned' | 'bursting';
  /** All addresses from which data can egress from the workspace */
  egressIpAddresses: string[];
  /** The estimated ingest gigabytes per day for this worker group. */
  estimatedIngestGB?: number;
  /** Array of fully qualified domain names for this worker group. This is an array because we still support main & logstream workspaces. */
  FQDNs: string[];
  /** This worker group's ingest fully qualified domain name. */
  ingestFQDN: string;
  /** All addresses that will access ingress traffic. Use for network ACL purposes only. Actual ingest should occur via the DNS names provided. */
  ingressIpAddresses: string[];
  /** The type of worker group */
  kind?: 'worker_group' | 'stream' | 'lake_access' | 'local_search';
  /** The IP addresses of the leader's NLB */
  leaderNlbIpAddresses: string[];
  /** The name of the worker group */
  name: string;
  /** AWS principals allowed to access the PrivateLink endpoint. Only applies to AWS worker groups. */
  privatelinkAllowedPrincipals?: string[];
  /** Azure subscription IDs allowed to access (and auto-approve on) the PrivateLink service. Only applies to Azure worker groups. */
  privatelinkAllowedSubscriptionIds?: string[];
  /** DNS name for the PrivateLink endpoint. */
  privatelinkDNSName?: string;
  /** Azure Private Link Service alias (e.g. alias.guid.region.azure.privatelinkservice). Present only on Azure worker groups once PrivateLink has been provisioned. */
  privatelinkServiceAlias?: string;
  /** AWS VPC Endpoint Service name (e.g. com.amazonaws.vpce.us-west-2.vpce-svc-...). Present only on AWS worker groups once PrivateLink has been provisioned. */
  privatelinkServiceName?: string;
  /** This indicates whether the infrastructure is provisioned for this worker group. */
  provisioned?: boolean;
  /** The cloud region where this worker group is deployed. */
  region?: string;
  /** All the Subject Alternate Names for this worker group's security certificate. */
  SANs: string[];
  /** Identifier of the entity that will connect to external resources if configured to do so. */
  trustPrincipalArn: string;
};

export type WorkerGroupOperation = {
  /** The name of the worker group */
  operationType: 'provision';
};

export type WorkerGroups = WorkerGroup[];
export type Workspace = {
  /** the display name of the workspace */
  alias?: string;
  /** ISO date string until which Cribl updates are blocked */
  blockCriblUpdatesUntil?: string;
  /** Resolved workspace-scoped capabilities only. */
  capabilities?: WorkspaceCapabilities;
  /** The certificate renewal date for this workspace */
  certificateRenewalDate?: string;
  /** The release channel the workspace is subscribed to. Source of truth for the release channel; prefer this over legacy productBuildSubscription.channel. */
  channelSubscription?: string;
  /** the description of the workspace */
  description?: string;
  /** Array of DNS name prefixes that this workspace uses */
  dnsNames: string[];
  /** Effective network egress mode for the workspace. "nat" means Static Egress IP is applied workspace-wide. "public" (the default) means dynamic egress. Ignored for any region present in egressTypeByRegion when that map is set. */
  egressType?: 'public' | 'nat';
  /** Per-provider, per-region network egress mode. Keyed by cloud provider (AWS, AZURE, GCP); each value maps a region name to its egress mode ("public" or "nat"). Null/omitted means not configured, and the flat egressType applies to every region. When present it is the sole source of truth per region and egressType is ignored. */
  egressTypeByRegion?: {
    AWS?: Record<string, 'public' | 'nat'>;
    AZURE?: Record<string, 'public' | 'nat'>;
    GCP?: Record<string, 'public' | 'nat'>;
  } | null;
  /** Array of fully qualified domain names for this workspace. This is an array because we are still supporting main & logstream. */
  FQDNs: string[];
  /** Whether this workspace is hybrid-only */
  hybridOnly?: boolean;
  /** Summary of the workspace's last infrastructure operation, derived from the internal task state. 'in-progress' means a deploy is still running; 'settled' means it completed successfully; 'failed' means it finished with a failure. Used to distinguish Insights still provisioning from Insights provisioning stuck/failed. */
  infraOperationState?: 'in-progress' | 'settled' | 'failed';
  /** the infrastructure configuration for this workspace */
  infrastructure?: Record<string, unknown>;
  /** Whether the workspace is currently undergoing an availability-impacting infrastructure operation, and so is unreachable until that operation completes. Present and true only while such an operation is still in flight. Omitted once it settles, and omitted for operations that do not impact availability. The field is never returned as false. */
  inMaintenanceMode?: true;
  /** Whether Cloud Insights is enabled for this workspace */
  insightsEnabled?: boolean;
  /** UTC Epoch timestamp when the last update was applied */
  lastUpdated: string;
  /** This is the main workspace's fully qualified domain name. */
  leaderFQDN: string;
  /** The name of the workspace (also serves as the workspace ID) */
  name: string;
  /**
   * The release channel subscription for this workspace
   * @deprecated
   */
  productBuildSubscription?: {channel: string; version: string};
  /** Formatted product build version string */
  productBuildVersionFull?: string;
  /** The quality designation of the product build running on this workspace */
  quality?: string;
  /** Additional quality detail from image filters */
  qualityDetail?: string;
  /** The region the leader of this workspace is running in */
  region: string;
  /** the current provisioning state of the workspace */
  state?: string;
  /** the tags associated with the workspace */
  tags?: string[];
  /** the version of Stream this workspace is running */
  version: string;
  /** Full version string including quality and quality detail */
  versionFull?: string;
};

export type WorkspaceCapabilities = {
  /** Per-workspace limit on the number of ACL rules. */
  'cloud.network.aclLimit': {maxAclRules: number};
  /** Controls whether Static Egress IP can be configured for the workspace. */
  'cloud.network.egressTypeNAT': {enabled: boolean};
  'cloud.network.privateLink': {enabled: boolean; maxCrossRegions: number; maxPrivateLinks: number};
  'cloud.product.advancedLakeFeatures': {enabled: boolean};
  'cloud.product.customerMetrics': {enabled: boolean};
  'cloud.product.search': {enabled: boolean};
  'cloud.product.systemInsights': {enabled: boolean};
  'cloud.workspace.connectedDeployments': {enabled: boolean};
  'cloud.workspace.releaseChannels': {enabled: boolean};
};

/** Represents a client returned by workspace-specific API. Does not include the client secret. */
export type WorkspaceClient = {
  /** The name of the client assigned by the user */
  clientAssignedName?: string;
  /** The client ID of the client */
  clientId?: string;
  /**
   * The email address of the creator of the client
   * @format email
   */
  createdBy?: string;
  /** The date the client was created */
  createdDate?: string;
  /** The role of the creator of the client */
  creatorRole?: string;
  /** The description of the client */
  description?: string;
  /** Whether the client is enabled or not */
  enabled?: boolean;
  /** Grants given to the client, admin api only */
  grants?: Record<string, unknown>[];
  /** CIDR ranges from which the API client can make requests */
  ipAllowlist?: string[];
  /**
   * The email address of the last user to update the client
   * @format email
   */
  lastUpdatedBy?: string;
  /** The date the client was last updated */
  lastUpdatedDate?: string;
  /** The Cribl name of the client inc prefixes/suffixes */
  name?: string;
  /** The organization ID the client belongs to */
  organizationId?: string;
  /** Product level roles assigned to the client per workspace */
  productRoles?: Record<string, unknown>[];
  /** Organization level role assigned to the client */
  role?: string;
  /** Whether this is a system-managed client */
  system?: boolean;
  /** The workspace this client is scoped to */
  workspaceName?: string;
  /** Workspace level roles assigned to the client */
  workspaceRoles?: Record<string, unknown>[];
};

export type WorkspacePrivateLink = {
  /** Whether to provision the workspace PrivateLink service. */
  createPrivatelink: boolean;
  /** AWS principals allowed to access the workspace PrivateLink endpoint. */
  privatelinkAllowedPrincipals?: string[];
  /** DNS name for the workspace PrivateLink endpoint. */
  privatelinkDNSName?: string;
  /** AWS VPC Endpoint Service name (e.g. com.amazonaws.vpce.us-west-2.vpce-svc-...). Present once the leader PrivateLink service has been provisioned. */
  privatelinkServiceName?: string;
  /** Worker group PrivateLink configuration details. Present when includeWorkerGroups=true. */
  workerGroups?: WorkspacePrivateLinkWorkerGroup[];
};

export type WorkspacePrivateLinkWorkerGroup = {
  /** The cloud provider hosting this worker group. Defaults to AWS when the stored cloudProviderKind is null or undefined. */
  cloud: 'AWS' | 'AZURE';
  /** Whether to provision the PrivateLink service for this worker group. */
  createPrivatelink?: boolean;
  /** The name of the worker group. */
  name: string;
  /** AWS principals allowed to access the PrivateLink endpoint. Only applies to AWS worker groups. */
  privatelinkAllowedPrincipals?: string[];
  /** Azure subscription IDs allowed to access (and auto-approve on) the PrivateLink service. Only applies to Azure worker groups. */
  privatelinkAllowedSubscriptionIds?: string[];
  /** DNS name for the PrivateLink endpoint. */
  privatelinkDNSName?: string;
  /** Azure Private Link Service alias (e.g. alias.guid.region.azure.privatelinkservice). Present only on Azure worker groups once PrivateLink has been provisioned. */
  privatelinkServiceAlias?: string;
  /** AWS VPC Endpoint Service name (e.g. com.amazonaws.vpce.us-west-2.vpce-svc-...). Present only on AWS worker groups once PrivateLink has been provisioned. */
  privatelinkServiceName?: string;
  /** Whether infrastructure has been provisioned for this worker group. */
  provisioned?: boolean;
};

export type WorkspaceRole = {
  role?: string;
  workspaceName?: string;
};

export type WorkspaceRoles = WorkspaceRole[];
export type Workspaces = Workspace[];
